import React from 'react';



class ContentLayout extends React.PureComponent {
  getDuration = (e) => {
    if (e.key === 'map') {
      return 800;
    }
    return 1000;
  };
  render() {
    const { isMobile, data } = this.props;
    return (
      <div id={ data.id} className='content' style={{ background: data.background || '' }}>
        <div className='content-container'>
          <div className={`content-container-title ${data.titleClassName}` }>{data.title}</div>
          <div className={`content-container-subTitle `}>{data.subTitle}</div>
          {React.isValidElement(data.content) ? React.cloneElement(data.content, { isMobile }) : data.content}
        </div>
      </div>
    );
  }
}

export default ContentLayout;
